import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";

export interface INotificationIconProps extends ISvgIconProps {

}

export class NotificationIcon extends React.Component<INotificationIconProps> {
    render() {
        return (
            <SvgIcon viewBox="0 0 52 52" {...this.props}>
                <g stroke="currentColor" strokeWidth="4.0" strokeLinejoin="round" fill="none">
                    <path stroke="null" d="m30.46234,46.08066c0,1.81614 -1.9091,3.28845 -4.26418,3.28845s-4.2659,-1.47231 -4.2659,-3.28845"/>
                    <path stroke="null" d="m26.88256,4.12778l0,2.80532" strokeLinecap="round"/>
                    <path stroke="null" strokeLinecap="round" d="m37.98898,19.64609a11.79253,12.12231 0 0 0 -23.58507,0l0,7.67188a17.08074,17.55839 0 0 1 -5.36024,12.05707l0,2.19171l34.30556,0l0,-2.19171a17.08074,17.55839 0 0 1 -5.36024,-12.05707l0,-7.67188z"/>
                </g>
            </SvgIcon>
        );
    }
}